import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MyTrans } from '@halo/ui-react';
import { useIsMyMsg } from '@halo/chat-sdk-react';
import { useMsgMediaTitle } from '../msg-media-call';

export interface MsgMediaCallTimeoutContentProps {
  message: Msg;
}

export const MsgMediaCallTimeoutContent = memo(function MsgMediaCallTimeoutContent({
  message,
}: MsgMediaCallTimeoutContentProps) {
  const { t } = useTranslation();
  const { type } = message.payload;
  const isMe = useIsMyMsg(message);

  const { typeDisplay } = useMsgMediaTitle({ type });

  return (
    <MyTrans
      i18nKey={isMe ? t('chat.mediaCallTimeoutMeText') : t('chat.mediaCallTimeoutText')}
      components={{
        component: <Text as="span" color="fg.muted" px="0.5" />,
      }}
      values={{
        value: typeDisplay,
      }}
    ></MyTrans>
  );
});
